/**
 * BreadCrumb Component
 *
 * Description: This component renders a breadcrumb navigation with a current page title, previous page link, and an optional button for additional actions. It uses FontAwesome for icons and React Router for navigation.
 *
 * File Name: BreadCrumb.jsx
 * Date: 23-07-2024
 */

import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import BackIcon from "../../assets/images/back-icon.png";
import exportIcon from "../../assets/images/export-icon-order.png";
import deleteIcon from "../../assets/images/delete-icon-order.png";
import printIcon from "../../assets/images/print-icon-order.png";

interface IBreadCrumbProps {
  current: string;
  previous: string;
  navigateUrl: string;
  btnText?: string;
  onPress?: () => void;
  btnShow?: boolean;
  isUpsert?: boolean;
  pharmaOrderIcon?: boolean;
  AllOrders?: boolean;
  btnClassName?: any;
  onPressExport?: () => void;
  onPressPrint?: () => void;
  onDeleteItem?: () => void;
  BtnId?: string;
}

const BreadCrumb: React.FC<IBreadCrumbProps> = ({
  btnClassName = "",
  current = "",
  previous = "",
  navigateUrl = "/",
  btnText = "",
  onPress = () => {},
  onPressExport = () => {},
  onPressPrint = () => {},
  btnShow = false,
  pharmaOrderIcon = false,
  onDeleteItem = () => {},
  isUpsert = false,
  AllOrders = false,
  BtnId = "",
}) => {
  return (
    <div className="bread__crumb">
      <div className="flex items-end justify-between">
        <div className="left__bar">
          <h1 className="font-size-36px font-Poppins-Medium capitalize">
            {current}
          </h1>
          <span className="font-size-18px font-Poppins-Medium capitalize">
            <Link className="font-Poppins-Bold" to={navigateUrl}>
              {previous}
            </Link>{" "}
            / {current}
          </span>
        </div>
        {AllOrders ? (
          <button className="right-bar-icon" id="export-btn" onClick={onPressExport}>
            <img src={exportIcon} alt="back-icon" />
          </button>
        ) : null}
        {btnShow && (
          <div className="flex gap-3">
            {pharmaOrderIcon ? (
              <>
                <button className="right-bar-icon" id="export-btn" onClick={onPressExport}>
                  <img src={exportIcon} alt="back-icon" />
                </button>
                <button onClick={onDeleteItem} className="right-bar-icon" id="delete-btn">
                  <img src={deleteIcon} alt="back-icon" />
                </button>
                <button className="right-bar-icon" id="print-btn" onClick={onPressPrint}>
                  <img src={printIcon} alt="back-icon" />
                </button>
              </>
            ) : null}
            {isUpsert ? (
              <button id="back-page-btn" className="right-bar-icon" onClick={onPress}>
                <img src={BackIcon} alt="back-icon" />
              </button>
            ) : (
              <button
                onClick={onPress}
                id={BtnId}
                className={`right__bar font-size-15px font-Poppins-Medium capitalize ${btnClassName}`}
              >
                <FontAwesomeIcon icon={faPlus} />
                {btnText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BreadCrumb;
